
    import './styles.scoped.css';
    export default {
  "top-navigation": "awsui_top-navigation_1ca1i_1156u_3",
  "padding-box": "awsui_padding-box_1ca1i_1156u_13",
  "medium": "awsui_medium_1ca1i_1156u_23",
  "narrow": "awsui_narrow_1ca1i_1156u_23",
  "hidden": "awsui_hidden_1ca1i_1156u_31",
  "\t": "awsui_\t_1ca1i_1156u_1",
  "identity": "awsui_identity_1ca1i_1156u_44",
  "identity-link": "awsui_identity-link_1ca1i_1156u_44",
  "no-logo": "awsui_no-logo_1ca1i_1156u_61",
  "logo": "awsui_logo_1ca1i_1156u_65",
  "title": "awsui_title_1ca1i_1156u_76",
  "inputs": "awsui_inputs_1ca1i_1156u_90",
  "search": "awsui_search_1ca1i_1156u_97",
  "search-expanded": "awsui_search-expanded_1ca1i_1156u_102",
  "utilities": "awsui_utilities_1ca1i_1156u_107",
  "utility-wrapper": "awsui_utility-wrapper_1ca1i_1156u_119",
  "utility-wrapper-last": "awsui_utility-wrapper-last_1ca1i_1156u_135",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_1ca1i_1156u_135",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_1ca1i_1156u_149",
  "utility-type-button-link": "awsui_utility-type-button-link_1ca1i_1156u_164",
  "utility-link-icon": "awsui_utility-link-icon_1ca1i_1156u_177",
  "utility-button-external-icon": "awsui_utility-button-external-icon_1ca1i_1156u_181",
  "trigger": "awsui_trigger_1ca1i_1156u_185",
  "rotate-up": "awsui_rotate-up_1ca1i_1156u_189",
  "rotate-down": "awsui_rotate-down_1ca1i_1156u_204"
};
  